{
    "table_header__product_name": "Article",
    "table_header__line_status": "Statut",
    "table_header__quantity_ordered": "Quantité",
    "table_header__rebate": "Remise",
    "table_header__price": "Prix",
    "table_header__total": "Total",
    "table_header__gross_margin": "MB",
    "table_header__gross_margin_percentage": "MB %",
    "table_header__encrypted_purchase_price": "Prix d'achat codé"
}
